import { render } from "./WorkDetail.vue?vue&type=template&id=689b8148&scoped=true"
import script from "./WorkDetail.vue?vue&type=script&lang=js"
export * from "./WorkDetail.vue?vue&type=script&lang=js"

import "./WorkDetail.vue?vue&type=style&index=0&id=689b8148&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-689b8148"

export default script